import { GeneralTextModalProps } from '@mm/state/modules/modalsState/props';
import classNames from 'classnames';
import React from 'react';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import './GeneralTextModal.pcss';

const GeneralTextModal = (props: GeneralTextModalProps) => {
  const {
    onClose = () => {},
    closeModal = () => {},
    closeOverride,
    message,
    header,
    headerClassName = '',
    className = '',
  } = props;
  const closeButtonText = props.closeButtonText || 'Ok';

  const containerClassName = classNames('general-text-modal', className);
  return (
    <div className={containerClassName}>
      <ModalHeader
        className="general-text-modal__header"
        childrenContainerClassName={headerClassName}
        closeOverride={closeOverride}
      >
        {header}
      </ModalHeader>

      <ModalBody className="general-text-modal__body">{message}</ModalBody>

      <ModalFooter className="general-text-modal__footer">
        <PrimaryButton
          className="general-text-modal__close-button"
          onClick={() => {
            closeModal();
            onClose();
          }}
        >
          {closeButtonText}
        </PrimaryButton>
      </ModalFooter>
    </div>
  );
};

export default GeneralTextModal;
